var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg33(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 442,
    height: 380,
    viewBox: "0 0 442 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.98 102.853L213.881 113.932L160.394 229.223L234.013 333.42L361.096 322.335L414.583 207.043L340.98 102.853Z",
    fill: "#ACA4E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.063 61.6151L198.128 103.79L172.086 203.939L234.561 286.63L338.431 289.661L405.581 210.716L385.392 109.225L293.063 61.6151Z",
    fill: "#776BCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.907 12.2894L38.5978 42.9056L8.28075 129.94L57.7841 207.837L149.775 217.994L215.076 152.74L204.448 61.1909L125.907 12.2894Z",
    fill: "#776BCE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg33);
export default __webpack_public_path__ + "static/media/33.9842090868f791bab772833cd170e6df.svg";
export { ForwardRef as ReactComponent };